import { useEffect, useState } from 'react';
import { useStore } from '../contexts/StoreContext';
import { useAuth } from '../contexts/AuthContext';
import { loadYouReadModel, type YouReadModel } from '../lib/you/read-model';

const EMPTY_MODEL: YouReadModel = {
  isReady: false,
  profileLoaded: false,
  profile: null,
  observations: [],
  characterSummary: null,
  timeline: [],
  ikigaiNodes: [],
  demographicLabels: [],
};

export function useYouReadModel() {
  const { store, isReady } = useStore();
  const { wallet, isLoading: authLoading } = useAuth();
  const userId = wallet?.address ?? null;
  const [model, setModel] = useState<YouReadModel>(EMPTY_MODEL);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!isReady || authLoading) {
      setModel(EMPTY_MODEL);
      setIsLoading(true);
      return;
    }
    if (!userId) {
      setModel(EMPTY_MODEL);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    loadYouReadModel(store, userId)
      .then((nextModel) => {
        if (!cancelled) setModel(nextModel);
      })
      .catch(() => {
        if (!cancelled) setModel({ ...EMPTY_MODEL, isReady: true });
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [store, isReady, authLoading, userId]);

  return { ...model, isLoading, userId: userId ?? '' };
}
